import {
  GOOGLE_LOGIN_START,
  GOOGLE_LOGIN_ERROR,
  GOOGLE_LOGIN_SUCCESS,
  GOOGLE_SIGNUP_START,
  GOOGLE_SIGNUP_ERROR,
  GOOGLE_SIGNUP_SUCCESS
} from './actions'

const initialState = window.__STATE__.googleAuth || {}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GOOGLE_LOGIN_START:
      return {
        ...state,
        login: {
          isProcessing: true,
        }
      }
    case GOOGLE_LOGIN_SUCCESS:
    case GOOGLE_LOGIN_ERROR:
      return {
        ...state,
        login: action
      }
    case GOOGLE_SIGNUP_START:
      return {
        ...state,
        signup: {
          isProcessing: true,
        }
      }
    case GOOGLE_SIGNUP_SUCCESS:
    case GOOGLE_SIGNUP_ERROR:
      return {
        ...state,
        signup: action,
      }
    default:
      return state
  }
}
